import type { SystemErrorStatusValues } from '@repo/common';

import { RivaasError } from './rivaas-error';

export class SystemError extends RivaasError {
  public constructor(
    public status?: SystemErrorStatusValues,
    tracingId?: string,
    message?: string,
  ) {
    super(status, tracingId, message);
    this.name = 'SystemError';
  }
}
